
import { defineComponent } from 'vue';
import { TButton } from '@tencent/web-vbui';
import { CommonTitle } from './components';
import LangVue from '@common/components/ui/lang.vue';
import { i18n, reportStatistics } from '@tencent/vb-web-base';
import { getQuery } from '@tencent/multi-url';
import { baseMixins } from '@common/mixins/baseMixins';
import ClipboardJS from 'clipboard';
import { toast } from '@tencent/web-vbui/dist/components/t-toast/toast';
import Contract from '@tencent/vb-web-contract';
export default defineComponent({
  components: {
    TButton,
    CommonTitle,
    LangVue,
  },
  setup() {
    const { getT, getLang } = i18n;
    const $t = getT();
    const lang = getLang();
    const { setTitle, isEng } = baseMixins();
    setTitle($t('贷款优惠活动'));
    const { inviteCode } = getQuery();
    const handleClick = () => {
      const clipboard = new ClipboardJS('.activity-copy');
      reportStatistics({
        evtName: 'copyCode',
        desc: '复制邀请码',
      });
      clipboard.on('success', () => {
        toast.show({
          title: $t('复制成功'),
        });
        clipboard.destroy();
      });
      clipboard.on('error', (err) => {
        console.log(err);
        toast.show({
          title: $t('复制失败'),
        });
        clipboard.destroy();
      });
    };

    // 查看协议
    const checkProto = () => {
      const contract = new Contract({
        key: 'TeslaMGM01',
        needLogin: false,
        autoSign: false,
        containerType: 'dialog',
        needAgree: false,
        needCheckBox: false,
        hideBtn: true,
        needTitle: false,
      });
      contract.preview();
    };
    return {
      lang,
      isEng,
      inviteCode,
      handleClick,
      checkProto,
    };
  },
});
